/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

/**
 * @type {import('react').Context<{ tooltip?: import('reakit').TooltipState }>}
 */
export const TooltipContext = createContext( {} );
export const useTooltipContext = () => useContext( TooltipContext );
